<template>
  <div class="home">
    <div class="wrap">
        {{ message }} Index component
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      message: ""
    }
  },
  created: function() {
  }
}
</script>
